import { FC, PropsWithChildren, useContext } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { Context } from "..";
import Button from "./Button";
import { observer } from "mobx-react";

const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 50px;
  max-width: 1010px;
  margin: 0 auto;
  gap: 30px;
  @media(max-width: 480px) {
    padding-left: 24px;
    padding-right: 24px;
  }
`;

const DayReport = styled(Button)`
  position: absolute;
  right: 10px;
  top: 10px;
  width: 100px;
  height: 37px;
  min-height: auto;
`;

const ToAdmin = styled(DayReport)`
  position: absolute;
  left: 10px;
  top: 10px;
  color: red;
  background: transparent;
  width: 200px;
  font-size: 14px;
  text-align: left;
  padding: 0;
  :hover {
    text-decoration: underline;
  }
`;

const ToDefault = styled(ToAdmin)`
  top: 60px;
`;

const Layout: FC<PropsWithChildren<{ className?: string; title: string }>> = observer(({ children, className, title }) => {
  const { store } = useContext(Context);
  return (
    <Column className={className}>
      <title>{title}</title>
      {children}
      {store.isAuth && (
        <Link to="/default/report">
          <DayReport>Отчет</DayReport>
        </Link>
      )}
      {store.isAuth && store.user.type === "admin" && (
        <>
          <Link to="/admin">
            <ToAdmin>Админ-панель</ToAdmin>
          </Link>
          <Link to="/default">
            <ToDefault>Панель мастеров</ToDefault>
          </Link>
        </>
      )}
    </Column>
  );
});

export default Layout;
